import { inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';

import { EVENT_SOURCE_URL } from './tokens.service';

@Injectable({
  providedIn: 'root'
})
export class ImportAnnexureService {
    private eventSource!: EventSource;
    private oktaAuth = inject(OKTA_AUTH);
    private baseUrl = inject(EVENT_SOURCE_URL);
    private connectionEstablished = false;
    private messageReceived = false;

    startListening(batchId: number, onProgress: (progress: any) => void, onError?: () => void) {
        const accessToken = this.oktaAuth.getAccessToken();
        this.connectionEstablished = false;
        this.messageReceived = false;

        this.eventSource = new EventSource(`${this.baseUrl}/annexure/${batchId}/import-data?access_token=${accessToken}`);

        this.eventSource.onopen = () => {
            this.connectionEstablished = true;
        };

        this.eventSource.onmessage = (event) => {
            if (!this.messageReceived) {
                this.messageReceived = true;
            }

            const progress = JSON.parse(event.data);

            if (progress) {
                onProgress(progress);

                if (progress.progress === 100 || progress.message === 'Import completed.') {
                    this.stopListening();
                }
            }
        };

        this.eventSource.onerror = (error) => {
            if (!this.messageReceived && onError) {
                onError();
            }

            this.stopListening();
        };

        // Add timeout to detect if connection never establishes
        setTimeout(() => {
            if (!this.connectionEstablished) {
                if (onError) {
                    onError();
                }

                this.stopListening();
            }
        }, 10000); // 10 second timeout
    }

    stopListening() {
        if (this.eventSource) {
            console.log(`[ImportAnnexureService] Closing SSE connection`);
            this.eventSource.close();
        }
    }
}